import { Outlet, useOutletContext } from "react-router-dom";

export default function Index() {
  const { helps } = useOutletContext();

  return (
    <div className="row flex-nowrap">
      <Outlet context={{ helps }} />
    </div>
  );
}
